export const UMB_DOCUMENT_WORKSPACE_ALIAS = 'Umb.Workspace.Document';
